import { getRaw, postRaw, ApiMethod } from 'services/api';
import { useRestMutation, UseRestMutationOptions } from 'utils/hooks/api';

export const THIRD_PARTY_INTEGRATIONS_URL = '/integrations/thirdParty.json';
export const CREATE_INTEGRATION_URL = '/integrations/addIntegration';
export const UPDATE_INTEGRATION_URL = '/integrations/updateIntegration';
export const DELETE_INTEGRATION_URL = '/integrations/deleteIntegration';

/**
 * getPurchases
 * gets a JSON list of third party integrations
 * @return { Object[] } Object containing a list of third party integrations
 */
export function getThirdPartyIntegrations() {
  return getRaw(THIRD_PARTY_INTEGRATIONS_URL);
}

export const useCreateThirdPartyIntegration = (options?: UseRestMutationOptions) =>
  useRestMutation(CREATE_INTEGRATION_URL, ApiMethod.post, options);

export function deleteIntegration(integrationId: number) {
  const payload = { id: integrationId };
  return postRaw(DELETE_INTEGRATION_URL, payload);
}

export const useUpdateThirdPartyIntegration = (options?: UseRestMutationOptions) =>
  useRestMutation(UPDATE_INTEGRATION_URL, ApiMethod.post, options);
